// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================
   Root Theme
======================== */
:root {
  --bg-page: #eef1ff;
  --bg-card: #ffffff;
  --bg-soft: #f5f7ff;
  --border-subtle: rgba(129, 140, 248, 0.18);
  --border-strong: rgba(79, 70, 229, 0.65);
  --text-main: #0f172a;
  --text-muted: #6b7280;
  --accent-500: #6366f1;
  --accent-600: #4f46e5;
  --accent-700: #4338ca;
  --accent-soft: rgba(99, 102, 241, 0.12);
  --success: #10b981;
  --danger: #ef4444;
  --radius-lg: 16px;
  --radius-md: 12px;
  --shadow-soft: 0 18px 40px rgba(15, 23, 42, 0.08);
  --shadow-sm: 0 8px 20px rgba(15, 23, 42, 0.06);
}

/* ========================
   Page Layout
======================== */

.apply-layout {
  max-width: 1240px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;
  align-items: flex-start;
}

/* ========================
   Main Form Area
======================== */
.apply-main {
  background: linear-gradient(180deg, #ffffff, #f9fafb);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  border: 1px solid rgba(148, 163, 184, 0.15);
  padding: 1.5rem 1.75rem 1.75rem;
}

.apply-main-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.1rem;
}

.apply-main-header h2 {
  margin: 0;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
  color: var(--text-main);
}

.apply-main-header p {
  margin: 0.25rem 0 0;
  color: var(--text-muted);
  font-size: 0.95rem;
}

/* Step strip */
.apply-step-strip {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.4rem 0.7rem;
  border-radius: 999px;
  background: rgba(129, 140, 248, 0.06);
  border: 1px solid rgba(129, 140, 248, 0.22);
  font-size: 0.78rem;
}

.apply-step-strip .step {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--text-muted);
}
.apply-step-strip .step.active {
  color: var(--accent-600);
  font-weight: 600;
}
.step-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--accent-500);
}

/* ========================
   Messages
======================== */
.msg {
  padding: 0.8rem 1rem;
  margin-bottom: 1rem;
  border-radius: var(--radius-md);
  font-size: 0.9rem;
  font-weight: 600;
}

.msg-success {
  background: #ecfdf3;
  color: #166534;
  border: 1px solid rgba(22, 101, 52, 0.12);
}
.msg-danger {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid rgba(185, 28, 28, 0.12);
}
.msg-warning {
  background: #fffbeb;
  color: #92400e;
  border: 1px solid rgba(146, 64, 14, 0.12);
}

/* ========================
   Form Sections
======================== */
.apply-form {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.form-section {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  padding: 1rem 1.1rem 1.1rem;
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.form-section::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, var(--accent-500), var(--accent-700));
  opacity: 0.9;
}

/* Section header */
.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
}

.section-header h3 {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--text-main);
}
.section-header p {
  margin: 0.15rem 0 0;
  color: var(--text-muted);
  font-size: 0.88rem;
}

.section-icon-wrap {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 30% 0, #e0e7ff, #eef2ff);
  border: 1px solid rgba(129, 140, 248, 0.35);
  color: var(--accent-600);
}

/* Subsection heading */
.subsection-heading {
  margin-top: 0.4rem;
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.subsection-heading.top-gap {
  margin-top: 1rem;
}

.subsection-heading h4 {
  margin: 0;
  font-size: 0.96rem;
  font-weight: 700;
}
.subsection-heading p {
  margin: 0.15rem 0 0;
  color: var(--text-muted);
  font-size: 0.86rem;
}

/* ========================
   NOTE CARD (shortlist requirements)
======================== */
.note-card {
  margin-bottom: 0.8rem;
  padding: 0.7rem 0.9rem;
  border-radius: 0.9rem;
  background: var(--bg-soft);
  border: 1px dashed rgba(129, 140, 248, 0.7);
  font-size: 0.86rem;
  color: var(--text-main);
}

.note-card strong {
  display: block;
  margin-bottom: 0.3rem;
}

.note-list {
  margin: 0;
  padding-left: 1.15rem;
}

.note-list li {
  margin: 0.15rem 0;
  color: var(--text-muted);
}

/* ========================
   Fields
======================== */
.field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.7rem;
}

.field-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-main);
}
.field-label span {
  color: #ef4444;
}

.hint {
  font-size: 0.8rem;
  color: var(--text-muted);
}

/* Grids */
.field-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem 1rem;
}

.field-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.8rem 1rem;
}

@media (max-width: 900px) {
  .field-grid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .field-grid-2,
  .field-grid-3 {
    grid-template-columns: 1fr;
  }
}

/* Inputs */
.input {
  width: 100%;
  padding: 0.7rem 0.85rem;
  border-radius: 0.7rem;
  border: 1px solid rgba(148, 163, 184, 0.45);
  font-size: 0.93rem;
  outline: none;
  background: #ffffff;
  transition: border 0.14s ease, box-shadow 0.14s ease, transform 0.1s ease;
}
.input::placeholder {
  color: #9ca3af;
}
.input:focus {
  border-color: var(--border-strong);
  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.6),
    0 18px 40px rgba(79, 70, 229, 0.14);
  transform: translateY(-1px);
}

/* ========================
   Pills – SHARED for Programming + Familiar
======================== */
.pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* base pill */
.pill-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151;
  transition: background 0.12s ease, border-color 0.12s ease,
    transform 0.08s ease;
}

/* hide inner checkbox when used as label */
.pill-pill input {
  display: none;
}

/* icon: completely hidden before active (no space) */
.pill-pill .pill-icon {
  display: none;
  font-size: 0.8rem;
}

/* hover (unselected) */
.pill-pill:hover {
  background: #f3f4ff;
  border-color: #a5b4fc;
  transform: translateY(-1px);
}

/* active selection – minimal */
.pill-pill.pill-active {
  background: #eef2ff;
  border-color: #6366f1;
  color: #111827;
}

/* show icon only when active */
.pill-pill.pill-active .pill-icon {
  display: inline-block;
  color: #4f46e5;
}

/* ========================
   Project / Certification Cards
======================== */
.card-stack {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.8rem;
}

.item-card {
  border-radius: 0.9rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f9fafb;
  padding: 0.8rem 0.85rem 0.9rem;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.08);
}

.item-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
}

.item-index {
  font-size: 0.82rem;
  font-weight: 700;
  padding: 0.22rem 0.6rem;
  border-radius: 999px;
  background: rgba(129, 140, 248, 0.12);
  color: var(--accent-700);
}

.empty-card {
  padding: 0.8rem 0.9rem;
  border-radius: 0.8rem;
  border: 1px dashed rgba(148, 163, 184, 0.7);
  background: #fdfdfb;
  font-size: 0.86rem;
  color: #854d0e;
}

/* Icon buttons */
.icon-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.35rem 0.6rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: #ffffff;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, border 0.12s ease,
    background 0.12s ease;
}
.icon-btn svg {
  width: 14px;
  height: 14px;
}
.icon-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.14);
}
.icon-btn.danger {
  color: var(--danger);
  border-color: rgba(239, 68, 68, 0.5);
}

/* Add buttons */
.chip-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  border: 1px solid rgba(129, 140, 248, 0.65);
  background: #f9fafb;
  font-size: 0.84rem;
  cursor: pointer;
  font-weight: 600;
}
.chip-btn.primary {
  background: linear-gradient(135deg, var(--accent-500), var(--accent-600));
  color: #ffffff;
  border-color: transparent;
}
.chip-btn svg {
  width: 14px;
  height: 14px;
}

/* ========================
   File Upload
======================== */
.file-row {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.file-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 1rem;
  border-radius: 0.75rem;
  border: 1px dashed rgba(129, 140, 248, 0.8);
  background: linear-gradient(135deg, #eef2ff, #f9fafb);
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
}
.file-btn input[type="file"] {
  display: none;
}
.file-icon {
  font-size: 1.1rem;
  color: var(--accent-600);
}

.file-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.4rem;
}

/* ========================
   Submit Row
======================== */
.submit-row {
  margin-top: 0.8rem;
  padding-top: 0.7rem;
  border-top: 1px solid rgba(226, 232, 240, 0.9);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.submit-text {
  font-size: 0.86rem;
  color: var(--text-muted);
}
.submit-text strong {
  color: var(--text-main);
}

/* Primary button */
.btn-primary {
  padding: 0.8rem 1.4rem;
  border-radius: 999px;
  background: radial-gradient(circle at top left, #a5b4fc, #4f46e5);
  color: #ffffff;
  border: none;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ========================
   Sidebar
======================== */
.apply-sidebar {
  position: sticky;
  top: 1rem;
}

.sidebar-card {
  background: radial-gradient(circle at 0 0, #4f46e5, #0f172a);
  color: #e5e7eb;
  border-radius: var(--radius-lg);
  padding: 1.3rem 1.2rem;
  box-shadow: 0 20px 46px rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(129, 140, 248, 0.5);
}

.sidebar-card h3 {
  margin: 0;
  font-size: 1.05rem;
}
.sidebar-sub {
  margin: 0.4rem 0 0.7rem;
  font-size: 0.86rem;
  opacity: 0.85;
}

.sidebar-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.6rem;
}

.sidebar-list li {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem 0.6rem;
  align-items: flex-start;
  padding: 0.4rem 0.45rem;
  border-radius: 0.8rem;
  background: rgba(15, 23, 42, 0.4);
}

.sidebar-list strong {
  font-size: 0.86rem;
}
.sidebar-list p {
  margin: 0.18rem 0 0;
  font-size: 0.8rem;
  opacity: 0.85;
}

.tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  background: rgba(129, 140, 248, 0.25);
  font-size: 0.72rem;
  font-weight: 600;
}

.sidebar-highlight {
  margin-top: 0.9rem;
  padding-top: 0.7rem;
  border-top: 1px dashed rgba(148, 163, 248, 0.5);
  font-size: 0.8rem;
}
.sidebar-highlight p {
  margin: 0.2rem 0;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.sidebar-highlight .dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #22c55e;
}

/* ========================
   Responsiveness
======================== */
@media (max-width: 950px) {
  .apply-layout {
    grid-template-columns: minmax(0, 1.9fr) minmax(260px, 1.4fr);
  }
}

@media (max-width: 820px) {
  .apply-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .apply-sidebar {
    position: static;
  }
}

@media (max-width: 640px) {
  .apply-main {
    padding: 1.1rem 1rem 1.3rem;
  }
  .apply-main-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .submit-row {
    flex-direction: column;
    align-items: stretch;
  }
  .btn-primary {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/ApplyForm.css"],"names":[],"mappings":"AAAA;;0BAE0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,wCAAwC;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;;0BAE0B;;AAE1B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,uBAAuB;AACzB;;AAEA;;0BAE0B;AAC1B;EACE,qDAAqD;EACrD,+BAA+B;EAC/B,8BAA8B;EAC9B,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;0BAE0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;0BAE0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,MAAM;EACN,SAAS;EACT,UAAU;EACV,yEAAyE;EACzE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8DAA8D;EAC9D,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;0BAE0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,WAAW;AACX;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yEAAyE;AAC3E;AACA;EACE,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC;uCACqC;EACrC,2BAA2B;AAC7B;;AAEA;;0BAE0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd;wBACsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;0BAE0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;yBACuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yEAAyE;EACzE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;0BAE0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,2CAA2C;EAC3C,qDAAqD;EACrD,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iEAAiE;EACjE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;0BAE0B;AAC1B;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4DAA4D;EAC5D,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;EACtB,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;0BAE0B;AAC1B;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* ========================\n   Root Theme\n======================== */\n:root {\n  --bg-page: #eef1ff;\n  --bg-card: #ffffff;\n  --bg-soft: #f5f7ff;\n  --border-subtle: rgba(129, 140, 248, 0.18);\n  --border-strong: rgba(79, 70, 229, 0.65);\n  --text-main: #0f172a;\n  --text-muted: #6b7280;\n  --accent-500: #6366f1;\n  --accent-600: #4f46e5;\n  --accent-700: #4338ca;\n  --accent-soft: rgba(99, 102, 241, 0.12);\n  --success: #10b981;\n  --danger: #ef4444;\n  --radius-lg: 16px;\n  --radius-md: 12px;\n  --shadow-soft: 0 18px 40px rgba(15, 23, 42, 0.08);\n  --shadow-sm: 0 8px 20px rgba(15, 23, 42, 0.06);\n}\n\n/* ========================\n   Page Layout\n======================== */\n\n.apply-layout {\n  max-width: 1240px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 1.5rem;\n  align-items: flex-start;\n}\n\n/* ========================\n   Main Form Area\n======================== */\n.apply-main {\n  background: linear-gradient(180deg, #ffffff, #f9fafb);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  border: 1px solid rgba(148, 163, 184, 0.15);\n  padding: 1.5rem 1.75rem 1.75rem;\n}\n\n.apply-main-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  margin-bottom: 1.1rem;\n}\n\n.apply-main-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  letter-spacing: -0.02em;\n  color: var(--text-main);\n}\n\n.apply-main-header p {\n  margin: 0.25rem 0 0;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n/* Step strip */\n.apply-step-strip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.4rem 0.7rem;\n  border-radius: 999px;\n  background: rgba(129, 140, 248, 0.06);\n  border: 1px solid rgba(129, 140, 248, 0.22);\n  font-size: 0.78rem;\n}\n\n.apply-step-strip .step {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--text-muted);\n}\n.apply-step-strip .step.active {\n  color: var(--accent-600);\n  font-weight: 600;\n}\n.step-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  background: var(--accent-500);\n}\n\n/* ========================\n   Messages\n======================== */\n.msg {\n  padding: 0.8rem 1rem;\n  margin-bottom: 1rem;\n  border-radius: var(--radius-md);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.msg-success {\n  background: #ecfdf3;\n  color: #166534;\n  border: 1px solid rgba(22, 101, 52, 0.12);\n}\n.msg-danger {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid rgba(185, 28, 28, 0.12);\n}\n.msg-warning {\n  background: #fffbeb;\n  color: #92400e;\n  border: 1px solid rgba(146, 64, 14, 0.12);\n}\n\n/* ========================\n   Form Sections\n======================== */\n.apply-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.form-section {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  padding: 1rem 1.1rem 1.1rem;\n  border: 1px solid var(--border-subtle);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.form-section::before {\n  content: \"\";\n  position: absolute;\n  inset-inline-start: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: linear-gradient(180deg, var(--accent-500), var(--accent-700));\n  opacity: 0.9;\n}\n\n/* Section header */\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.9rem;\n}\n\n.section-header h3 {\n  margin: 0;\n  font-size: 1.02rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n.section-header p {\n  margin: 0.15rem 0 0;\n  color: var(--text-muted);\n  font-size: 0.88rem;\n}\n\n.section-icon-wrap {\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: radial-gradient(circle at 30% 0, #e0e7ff, #eef2ff);\n  border: 1px solid rgba(129, 140, 248, 0.35);\n  color: var(--accent-600);\n}\n\n/* Subsection heading */\n.subsection-heading {\n  margin-top: 0.4rem;\n  margin-bottom: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n.subsection-heading.top-gap {\n  margin-top: 1rem;\n}\n\n.subsection-heading h4 {\n  margin: 0;\n  font-size: 0.96rem;\n  font-weight: 700;\n}\n.subsection-heading p {\n  margin: 0.15rem 0 0;\n  color: var(--text-muted);\n  font-size: 0.86rem;\n}\n\n/* ========================\n   NOTE CARD (shortlist requirements)\n======================== */\n.note-card {\n  margin-bottom: 0.8rem;\n  padding: 0.7rem 0.9rem;\n  border-radius: 0.9rem;\n  background: var(--bg-soft);\n  border: 1px dashed rgba(129, 140, 248, 0.7);\n  font-size: 0.86rem;\n  color: var(--text-main);\n}\n\n.note-card strong {\n  display: block;\n  margin-bottom: 0.3rem;\n}\n\n.note-list {\n  margin: 0;\n  padding-left: 1.15rem;\n}\n\n.note-list li {\n  margin: 0.15rem 0;\n  color: var(--text-muted);\n}\n\n/* ========================\n   Fields\n======================== */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 0.7rem;\n}\n\n.field-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n.field-label span {\n  color: #ef4444;\n}\n\n.hint {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n/* Grids */\n.field-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.8rem 1rem;\n}\n\n.field-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.8rem 1rem;\n}\n\n@media (max-width: 900px) {\n  .field-grid-3 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 700px) {\n  .field-grid-2,\n  .field-grid-3 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Inputs */\n.input {\n  width: 100%;\n  padding: 0.7rem 0.85rem;\n  border-radius: 0.7rem;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  font-size: 0.93rem;\n  outline: none;\n  background: #ffffff;\n  transition: border 0.14s ease, box-shadow 0.14s ease, transform 0.1s ease;\n}\n.input::placeholder {\n  color: #9ca3af;\n}\n.input:focus {\n  border-color: var(--border-strong);\n  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.6),\n    0 18px 40px rgba(79, 70, 229, 0.14);\n  transform: translateY(-1px);\n}\n\n/* ========================\n   Pills – SHARED for Programming + Familiar\n======================== */\n.pill-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n/* base pill */\n.pill-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.9rem;\n  border-radius: 999px;\n  border: 1px solid #d1d5db;\n  background: #f9fafb;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #374151;\n  transition: background 0.12s ease, border-color 0.12s ease,\n    transform 0.08s ease;\n}\n\n/* hide inner checkbox when used as label */\n.pill-pill input {\n  display: none;\n}\n\n/* icon: completely hidden before active (no space) */\n.pill-pill .pill-icon {\n  display: none;\n  font-size: 0.8rem;\n}\n\n/* hover (unselected) */\n.pill-pill:hover {\n  background: #f3f4ff;\n  border-color: #a5b4fc;\n  transform: translateY(-1px);\n}\n\n/* active selection – minimal */\n.pill-pill.pill-active {\n  background: #eef2ff;\n  border-color: #6366f1;\n  color: #111827;\n}\n\n/* show icon only when active */\n.pill-pill.pill-active .pill-icon {\n  display: inline-block;\n  color: #4f46e5;\n}\n\n/* ========================\n   Project / Certification Cards\n======================== */\n.card-stack {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.8rem;\n}\n\n.item-card {\n  border-radius: 0.9rem;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  background: #f9fafb;\n  padding: 0.8rem 0.85rem 0.9rem;\n  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.08);\n}\n\n.item-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.6rem;\n}\n\n.item-index {\n  font-size: 0.82rem;\n  font-weight: 700;\n  padding: 0.22rem 0.6rem;\n  border-radius: 999px;\n  background: rgba(129, 140, 248, 0.12);\n  color: var(--accent-700);\n}\n\n.empty-card {\n  padding: 0.8rem 0.9rem;\n  border-radius: 0.8rem;\n  border: 1px dashed rgba(148, 163, 184, 0.7);\n  background: #fdfdfb;\n  font-size: 0.86rem;\n  color: #854d0e;\n}\n\n/* Icon buttons */\n.icon-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.35rem 0.6rem;\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.5);\n  background: #ffffff;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.12s ease, box-shadow 0.12s ease, border 0.12s ease,\n    background 0.12s ease;\n}\n.icon-btn svg {\n  width: 14px;\n  height: 14px;\n}\n.icon-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.14);\n}\n.icon-btn.danger {\n  color: var(--danger);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n/* Add buttons */\n.chip-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid rgba(129, 140, 248, 0.65);\n  background: #f9fafb;\n  font-size: 0.84rem;\n  cursor: pointer;\n  font-weight: 600;\n}\n.chip-btn.primary {\n  background: linear-gradient(135deg, var(--accent-500), var(--accent-600));\n  color: #ffffff;\n  border-color: transparent;\n}\n.chip-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* ========================\n   File Upload\n======================== */\n.file-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.file-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.65rem 1rem;\n  border-radius: 0.75rem;\n  border: 1px dashed rgba(129, 140, 248, 0.8);\n  background: linear-gradient(135deg, #eef2ff, #f9fafb);\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n.file-btn input[type=\"file\"] {\n  display: none;\n}\n.file-icon {\n  font-size: 1.1rem;\n  color: var(--accent-600);\n}\n\n.file-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-top: 0.4rem;\n}\n\n/* ========================\n   Submit Row\n======================== */\n.submit-row {\n  margin-top: 0.8rem;\n  padding-top: 0.7rem;\n  border-top: 1px solid rgba(226, 232, 240, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.submit-text {\n  font-size: 0.86rem;\n  color: var(--text-muted);\n}\n.submit-text strong {\n  color: var(--text-main);\n}\n\n/* Primary button */\n.btn-primary {\n  padding: 0.8rem 1.4rem;\n  border-radius: 999px;\n  background: radial-gradient(circle at top left, #a5b4fc, #4f46e5);\n  color: #ffffff;\n  border: none;\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* ========================\n   Sidebar\n======================== */\n.apply-sidebar {\n  position: sticky;\n  top: 1rem;\n}\n\n.sidebar-card {\n  background: radial-gradient(circle at 0 0, #4f46e5, #0f172a);\n  color: #e5e7eb;\n  border-radius: var(--radius-lg);\n  padding: 1.3rem 1.2rem;\n  box-shadow: 0 20px 46px rgba(15, 23, 42, 0.85);\n  border: 1px solid rgba(129, 140, 248, 0.5);\n}\n\n.sidebar-card h3 {\n  margin: 0;\n  font-size: 1.05rem;\n}\n.sidebar-sub {\n  margin: 0.4rem 0 0.7rem;\n  font-size: 0.86rem;\n  opacity: 0.85;\n}\n\n.sidebar-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.6rem;\n}\n\n.sidebar-list li {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.5rem 0.6rem;\n  align-items: flex-start;\n  padding: 0.4rem 0.45rem;\n  border-radius: 0.8rem;\n  background: rgba(15, 23, 42, 0.4);\n}\n\n.sidebar-list strong {\n  font-size: 0.86rem;\n}\n.sidebar-list p {\n  margin: 0.18rem 0 0;\n  font-size: 0.8rem;\n  opacity: 0.85;\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.18rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(129, 140, 248, 0.25);\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.sidebar-highlight {\n  margin-top: 0.9rem;\n  padding-top: 0.7rem;\n  border-top: 1px dashed rgba(148, 163, 248, 0.5);\n  font-size: 0.8rem;\n}\n.sidebar-highlight p {\n  margin: 0.2rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n.sidebar-highlight .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: #22c55e;\n}\n\n/* ========================\n   Responsiveness\n======================== */\n@media (max-width: 950px) {\n  .apply-layout {\n    grid-template-columns: minmax(0, 1.9fr) minmax(260px, 1.4fr);\n  }\n}\n\n@media (max-width: 820px) {\n  .apply-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .apply-sidebar {\n    position: static;\n  }\n}\n\n@media (max-width: 640px) {\n  .apply-main {\n    padding: 1.1rem 1rem 1.3rem;\n  }\n  .apply-main-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .submit-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .btn-primary {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
